import { render } from "./LeadFunnelData.vue?vue&type=template&id=18feddf6"
import script from "./LeadFunnelData.vue?vue&type=script&lang=js"
export * from "./LeadFunnelData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__